// extracted by mini-css-extract-plugin
module.exports = {"CompactDesign":"CompactDesign_CompactDesign__H5fjS"};